export default {
  "content": "_content_1bnc4_1",
  "content--variant-elevated": "_content--variant-elevated_1bnc4_1",
  "content--elevation-raised": "_content--elevation-raised_1bnc4_1",
  "content--has-width": "_content--has-width_1bnc4_1"
};import "ni:sha-256;uIcxLasrFigqAs8DoJXXje1xKgRTHOd4trSjUGY-q2M";